import { Stack, Typography } from '@mui/material';
import dayjs from 'dayjs';

import AppIcon from '@/components/shared/AppIcon/AppIcon';

import { MainAppUserInfoDropdown } from '@/components/MainAppUserInfo/MainAppUserInfoDropdown';
import { MainAppLogo } from '@/components/MainAppLogo/MainAppLogo';
import GlobalSearchBar from '../GlobalSearchBar/GlobalSearchBar';

const { VITE_ENV } = import.meta.env;

export function MainAppHeader() {
  const today = dayjs().locale('en').format('DD MMM YYYY');

  return (
    <div className="flex h-[62px] w-full flex-row items-center justify-between border-b border-white border-opacity-10 bg-white bg-opacity-5 px-24">
      <div className="flex-shrink-0">
        <MainAppLogo />
      </div>

      {VITE_ENV !== 'production' && (
        <div className="flex items-center justify-center gap-8 rounded-lg border border-white/10 bg-zinc-800/70 px-12 py-4">
          <div className="h-8 w-8 rounded-full bg-red-500" />
          <Typography variant="caption" className="font-bold text-white uppercase">
            {VITE_ENV}
          </Typography>
        </div>
      )}
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        gap="24px"
      >
        <Stack
          direction="row"
          alignItems="center"
          gap="8px"
          className="hidden lg:flex"
        >
          <AppIcon
            name="calendar"
            width={16}
            className="text-white text-opacity-80"
          />
          <Typography variant="caption" className="text-white text-opacity-60">
            {today}
          </Typography>
        </Stack>
        <GlobalSearchBar />
        <MainAppUserInfoDropdown />
      </Stack>
    </div>
  );
}
